<template>
    <div>
        <b-card tag="article" style="max-width: 100%;" class="mb-2">
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="12" lg="12">
                        <app-form-select-input
                            v-if="clientRequired"
                            placeholder="Punto de acceso"
                            :options="accessPointList"
                            v-model="theRecommendation.structureId"
                            :hasError="$v.theRecommendation.structureId.$error"
                            errorMessage="Debe seleccionar el punto de acceso"
                            @change="$v.theRecommendation.structureId.$touch()"
                            :required="true"
                        />
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <app-form-textarea-input
                            label="Recomendación de seguridad"
                            id="description"
                            v-model="theRecommendation.description"
                            :hasError="$v.theRecommendation.description.$error"
                            errorMessage="Debe escribir la recomendación"
                            @change="$v.theRecommendation.description.$touch()"
                            :required="true"
                        />
                    </b-col>
                </b-row>
                <div v-if="!myRecommendation">
                    <b-row>
                        <b-col cols="12" md="6" lg="6">
                            <b-btn
                                v-b-toggle.collapse1
                                variant="primary"
                                class="btn-block"
                                ><i class="fa fa-plus" aria-hidden="true"></i>
                                Agregar fotos</b-btn
                            >
                        </b-col>
                    </b-row>
                    <b-collapse id="collapse1" class="mt-2">
                        <b-row>
                            <b-col cols="12" md="12" lg="12">
                                <b-card>
                                    <div class="card-text">
                                        <app-upload-or-take-photo
                                            id="safety-recommendation-photos"
                                            title="Fotos de recomendación de seguridad"
                                            v-model="files"
                                        />
                                        <div
                                            v-if="
                                                files.files &&
                                                    files.files.length
                                            "
                                        >
                                            <button
                                                class="btn btn-sm btn-danger pull-right"
                                                @click="cancelFilesSelected"
                                            >
                                                <i
                                                    class="fa fa-trash-o"
                                                    aria-hidden="true"
                                                ></i>
                                                Cancelar archivos seleccionados
                                            </button>
                                        </div>
                                    </div>
                                </b-card>
                            </b-col>
                        </b-row>
                    </b-collapse>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import safetyRecommendationsRepository from "../../../../repositories/safetyRecommendations.repository.js";
import Autocomplete from "../../../../components/UI/Controls/AutocompleteV2/Autocomplete.vue";
import { required } from "vuelidate/lib/validators";
import UploadOrTakePhoto from "../../../UI/Controls/Photos/UploadOrTakePhoto.vue";
import { getCurrentPosition } from "../../../../utils/localization";
export default {
    components: {
        appAutocomplete: Autocomplete,
        appUploadOrTakePhoto: UploadOrTakePhoto
    },

    props: {
        onSave: {
            type: Function
        },
        myRecommendation: {
            default: null
        },
        accessPoints: {
            type: Array,
            required: true
        },
        isSupervision: {
            type: Boolean,
            default: false
        },
        localization: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            clientRequired: false,
            isSupervisor: false,
            theRecommendation: {
                structureId: "",
                userId: "",
                description: ""
            },
            files: ""
        };
    },
    validations() {
        let theRecommendation;
        if (this.clientRequired) {
            theRecommendation = {
                structureId: { required },
                description: { required }
            };
        } else {
            theRecommendation = {
                description: { required }
            };
        }
        return { theRecommendation };
    },

    watch: {
        myRecommendation(val) {
            this.fillForm();
        }
    },
    computed: {
        accessPointList() {
            return this.accessPoints.map(item => ({
                ...item,
                name: `${item.name} (Sede: ${item.venue.name})`
            }));
        }
    },
    methods: {
        async saveRecommendation() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            const formData = new FormData();

            if (this.localization) {
                const { latitude, longitude } = await getCurrentPosition();

                formData.append("latitude", latitude);
                formData.append("longitude", longitude);
            }

            if (this.isSupervision) {
                //si es supervisor el user id deber ser el del supervisor logueado, validar
                this.theRecommendation.userId = this.$store.getters.supervisor.id;
            } else {
                this.theRecommendation.userId = this.user.id;
            }

            if (!this.clientRequired) {
                this.theRecommendation.structureId = this.accessPoint.id;
            }

            formData.append("structureId", this.theRecommendation.structureId);
            formData.append("userId", this.theRecommendation.userId);
            formData.append("description", this.theRecommendation.description);

            if (this.files.photos) {
                this.files.photos.map(item =>
                    formData.append("photos[]", item)
                );
            }
            if (this.files.files) {
                this.files.files.map((item, index) =>
                    formData.append("file" + index, item)
                );
            }

            const srr = { ...safetyRecommendationsRepository };
            srr.saveSafetyRecommendation(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanForm();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al guardar la recomendación de seguridad"
                    );
                });
        },
        updateRecommendation(id) {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error(
                    "Debe diligenciar correctamente todos los campos obligatorios"
                );
                return false;
            }

            if (!this.clientRequired) {
                this.theRecommendation.structureId = this.accessPoint.id;
            }

            const srr = { ...safetyRecommendationsRepository };
            srr.updateSafetyRecommendation(
                this.theRecommendation,
                this.myRecommendation.id
            )
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg);
                        this.cleanForm();
                        typeof this.onSave === "function" && this.onSave();
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error(
                        "Ocurrió un error al actualizar la recomendación de seguridad"
                    );
                });
        },
        saveOrUpdate() {
            if (!!this.myRecommendation) {
                this.updateRecommendation();
            } else {
                this.saveRecommendation();
            }
        },
        fillForm() {
            if (Object.keys(this.myRecommendation).length !== 0) {
                this.theRecommendation.description = this.myRecommendation.description;
                this.theRecommendation.structureId = this.myRecommendation.structure_id;
            } else {
                this.cleanForm();
            }
        },
        cleanForm() {
            Object.keys(this.theRecommendation).map(
                key => (this.theRecommendation[key] = "")
            );
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.$bus.$emit("safety-recommendation-photos.clean");
        },
        cancelFilesSelected() {
            this.$bus.$emit("safety-recommendation-photos.clean");
            this.files = "";
            toastr.success("Archivos cancelados");
        },
        initialize() {
            this.clientRequired = !this.user.profile.client_required
                ? true
                : false;
            this.isSupervisor =
                this.user.profile.slug === "supervisor" ? true : false;
        }
    },
    created() {
        this.initialize();
        this.$bus.$on("safety-recommendation-form.save", this.saveOrUpdate);
        this.$bus.$on("safety-recommendation-form.clean", this.cleanForm);
    },

    beforeDestroy() {
        this.$bus.$off("safety-recommendation-form.save");
    }
};
</script>
